import { useCallback } from 'react';
import { useParams } from 'next/navigation';
import { Currency } from '@/types/currency';
import { Address } from '@/types/entity/address';

const useFormat = () => {
  const { locale } = useParams();

  const formatCurrency = useCallback(
    (price: number, currency: Currency) => {
      const intlLocaleMapping = { en: 'en-US', sv: 'sv-SE' };

      const formattedPrice = new Intl.NumberFormat(intlLocaleMapping[locale as keyof typeof intlLocaleMapping], {
        style: 'currency',
        currency,
      }).format(price);

      // Remove only the currency code "A"
      return formattedPrice.replace('A', '').replace('NZ', '').trim();
    },
    [locale],
  );

  const formatAddress = useCallback((address: Address) => {
    return `${address.line1},\n${address.zip},\n${address.city},\n${address.country}`;
  }, []);

  return { formatCurrency, formatAddress };
};

export default useFormat;


